import { createTranslations } from '@momentum/i18n';
import { openBlockageEnTranslations } from './open-blockage.en';

export const openBlockageHeTranslations = createTranslations(
  openBlockageEnTranslations,
  {
    // Route component
    loading: 'טוען...',
    noFeedbackFormData: 'אין נתוני טופס משוב',
    noFeedbackCreator: 'אין יוצר משוב',
    noFeedbackReceiver: 'אין מקבל משוב',
    waitingFor: 'ממתין ל',
    toSeeTheFeedbackYouSent: 'לראות את המשוב ששלחת',
    notAllowedToViewFeedback: 'אין הרשאה לצפות במשוב זה',
    conversationDetails: 'פרטי שיחה',
    actionPlan: 'תכנית פעולה',
    errorUpdatingFeedback: 'שגיאה בעדכון משוב:',

    // Conversation Details
    yes: 'כן',
    no: 'לא',
    hi: 'שלום',
    youveReceivedRequestFrom: (name: string) => `קיבלת בקשה מ-${name}.`,
    readDetailsInvitation:
      'אנו מזמינים אותך לקרוא כאן את הפרטים ומקווים ששניכם תייצרו ערך משמעותי בתהליך.',
    detailsOfEvent: 'פרטי האירוע:',
    wantsToProvideFeedback: 'רוצה לספק משוב עבור:',
    thatDidNotOccurOn: 'שלא התרחש ב',
    descriptionOfIssue: (name: string) => `תיאור הבעיה של ${name}:`,
    areEventDetailsClear: 'האם פרטי האירוע ברורים לך?',
    impactOnGoals: (name: string) => `השפעה על הביצועים של ${name}`,
    accordingToImpact: (name: string, reason: string) =>
      `לפי ${name}, ההשפעה של ${reason}, על הסיכויים להשגת המטרה של ${name}`,
    is: 'היא',
    relativelyReduced: 'ירדה יחסית',
    significantlyReduced: 'ירדה משמעותית',
    extremelyReduced: 'ירדה באופן קיצוני',
    furtherImpact: 'השפעות נוספות',
    accordingToCompanyValue: (name: string) => `לפי ${name}, ערכי החברה`,
    areCompromised: 'נפגעים',
    isCompromised: 'נפגע',
    isItClearHowAffected: (name: string) => `האם ברור לך כיצד ${name} מושפע?`,
    isItClearHowGoalsAffected: (name: string) =>
      `האם ברור לך ההשפעה על הביצועים של ${name}?`,
    nowThatRequestIsClear: (name: string) =>
      `עכשיו שהבקשה ברורה לך, האם תעזור ל-${name}`,

    // Action Plan
    hereYouCanBuild: 'כאן תוכל לבנות את תכנית הפעולה שלך ב-3 שלבים קלים:',
    writeActionsThatHelp: (name: string) =>
      `כתוב את הפעולות שלדעתך יעזרו ל-${name}.`,
    ifYouNeedHelp: (name: string) =>
      `אם אתה צריך עזרה מ-${name}, מומלץ לכתוב את הפעולות במדור של ${name} (בצד ימין).`,
    doneIsItReady: (name: string) =>
      `סיימת? האם תכנית הפעולה מוכנה? כעת תוכל לשלוח אותה ל-${name} לאישור`,
    due: 'תאריך יעד:',
    enterTaskDescription: 'הזן תיאור משימה...',
    enterNewTaskDescription: 'הזן תיאור משימה חדשה...',
    selectDueDate: 'בחר תאריך יעד (אופציונלי)',
    addTask: 'הוסף משימה',
    sendActionPlan: 'שלח תכנית פעולה',
    sendApproveActionPlan: 'שלח תכנית פעולה מאושרת',
    closedAt: 'אינטרקציה נסגרה ב-',
    waitingForOtherPersonToAddTasks: (name: string) =>
      `אנא המתן ש-${name} יוסיף את המשימות שלו לפני שתוכל להוסיף את שלך.`,
    actionPlanPendingApprovalTitle: 'תכנית פעולה ממתינה לאישור',
  }
);
